'use client';

import {Box, styled, Typography} from '@mui/material';

export const StyledWideMediaContainer = styled(Box)(({ theme }) => ({
  position: 'relative',
  width: '100%',
  aspectRatio: '16 / 9',
  overflow: 'hidden',
  borderRadius: theme.shape.borderRadiusLg,
  margin: theme.spacing(0, 0, 5, 0),
}));


export const StyledWideMediaHeading = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.dark,
  textAlign: 'center',
}));
